enum DecimalSeparator {
    Pointer = '.',
    Comma = ','
}

export default DecimalSeparator;